module.exports = __webpack_public_path__ + "static/img/login_logo_1.9dc7656.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_logo_1.png
// module id = I/Ke
// module chunks = 3